// extracted by mini-css-extract-plugin
export default {"container":"wQqNGajcBlJeWm96LOU44g==","copy":"PhB9fMOWxHjyWKH+5cyFaw==","linkExternal":"hFlukDnlyMM5JZdWZfDkbw=="};